(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- Drawers (menu + winkelwagen) ---------- */
  var lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var f = el.querySelector('[data-close], a, button');
    if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(document.getElementById(opener.getAttribute('data-open')));
      return;
    }
    var closer = e.target.closest('[data-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer(closer.closest('.drawer'));
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.drawer.is-open').forEach(closeDrawer);
    }
  });

  /* ---------- Header: rand bij scrollen ---------- */
  var header = document.querySelector('.header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Zoekbalk ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-search-toggle]');
    if (!t) return;
    e.preventDefault();
    var bar = document.getElementById('SearchBar');
    if (!bar) return;
    bar.classList.toggle('is-open');
    if (bar.classList.contains('is-open')) bar.querySelector('input').focus();
  });

  /* ---------- Aantal-knoppen ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 0;
    v = b.getAttribute('data-qty') === 'plus' ? v + 1 : Math.max(input.min ? parseInt(input.min, 10) : 0, v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Winkelwagen (AJAX) ---------- */
  function renderCart(sections) {
    if (!sections || !sections['cart-drawer']) return;
    var html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = html.querySelector('[data-cart-inner]');
    var current = document.querySelector('[data-cart-inner]');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }
  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }
  function refreshCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { updateCount(c.item_count); return c; });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var err = form.querySelector('[data-form-error]');
    if (btn) btn.classList.add('is-loading');
    if (err) { err.hidden = true; err.textContent = ''; }
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.description) {
          if (err) { err.textContent = res.description; err.hidden = false; }
          return;
        }
        renderCart(res.sections);
        refreshCount();
        openDrawer(document.getElementById('CartDrawer'));
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  function changeLine(line, quantity) {
    var drawer = document.querySelector('[data-cart-inner]');
    if (drawer) drawer.style.opacity = '.55';
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: ['cart-drawer'], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        renderCart(res.sections);
        updateCount(res.item_count);
        if (document.body.classList.contains('template-cart')) window.location.reload();
      })
      .finally(function () { if (drawer) drawer.style.opacity = ''; });
  }
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    changeLine(parseInt(input.getAttribute('data-line-qty'), 10), Math.max(0, parseInt(input.value, 10) || 0));
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-line-remove]');
    if (!rm) return;
    e.preventDefault();
    changeLine(parseInt(rm.getAttribute('data-line-remove'), 10), 0);
  });

  /* ---------- Productgalerij ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var track = g.querySelector('.gallery__track');
    var slides = g.querySelectorAll('.gallery__slide');
    var thumbs = g.querySelectorAll('.gallery__thumb');
    var dots = g.querySelectorAll('.gallery__dots button');
    if (!track || slides.length < 2) return;
    function setActive(i) {
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    }
    function go(i) { track.scrollTo({ left: track.clientWidth * i }); setActive(i); }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    var tmr;
    track.addEventListener('scroll', function () {
      clearTimeout(tmr);
      tmr = setTimeout(function () { setActive(Math.round(track.scrollLeft / track.clientWidth)); }, 60);
    }, { passive: true });
  });

  /* ---------- Variant kiezen ---------- */
  document.querySelectorAll('[data-variant-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      var form = sel.closest('form');
      var price = document.querySelector('[data-product-price]');
      if (price && opt.dataset.price) price.innerHTML = opt.dataset.price;
      var btn = form && form.querySelector('[type=submit]');
      if (btn) {
        var available = opt.dataset.available === 'true';
        btn.disabled = !available;
        btn.querySelector('span').textContent = available ? 'In winkelwagen' : 'Uitverkocht';
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', sel.value);
      history.replaceState({}, '', url.toString());
    });
  });

  /* ---------- Collectie: sorteren & filteren ---------- */
  document.querySelectorAll('[data-auto-submit]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type=number]')) return;
      form.submit();
    });
  });

  /* ---------- Vaak samen gekocht ---------- */
  function fmt(c) { return '€ ' + (c / 100).toFixed(2).replace('.', ','); }
  document.querySelectorAll('[data-bundle]').forEach(function (b) {
    var items = b.querySelectorAll('[data-bundle-item]');
    var total = b.querySelector('[data-bundle-total]');
    var btn = b.querySelector('[data-bundle-add]');
    var err = b.querySelector('[data-bundle-error]');
    function update() {
      var sum = 0, n = 0;
      items.forEach(function (i) { if (i.checked) { sum += parseInt(i.dataset.price, 10) || 0; n++; } });
      if (total) total.textContent = fmt(sum);
      if (btn) btn.querySelector('span').textContent = n > 1 ? 'Beide in winkelwagen' : 'In winkelwagen';
    }
    items.forEach(function (i) { i.addEventListener('change', update); });
    if (btn) btn.addEventListener('click', function () {
      var list = [];
      items.forEach(function (i) { if (i.checked) list.push({ id: parseInt(i.value, 10), quantity: 1 }); });
      btn.classList.add('is-loading');
      if (err) err.hidden = true;
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: list, sections: ['cart-drawer'], sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status && res.description) { if (err) { err.textContent = res.description; err.hidden = false; } return; }
          renderCart(res.sections);
          refreshCount();
          openDrawer(document.getElementById('CartDrawer'));
        })
        .finally(function () { btn.classList.remove('is-loading'); });
    });
  });

  /* ---------- Vaste koopknop (mobiel) ---------- */
  var sticky = document.querySelector('[data-sticky-atc]');
  var buy = document.querySelector('form[data-product-form] .buy');
  if (sticky && buy && 'IntersectionObserver' in window) {
    var buyVisible = true, footVisible = false;
    var setSticky = function () {
      var show = !buyVisible && !footVisible && buy.getBoundingClientRect().top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      var sb = sticky.querySelector('[data-sticky-add]');
      if (sb) sb.tabIndex = show ? 0 : -1;
    };
    new IntersectionObserver(function (en) { buyVisible = en[0].isIntersecting; setSticky(); }).observe(buy);
    var foot = document.querySelector('.footer');
    if (foot) new IntersectionObserver(function (en) { footVisible = en[0].isIntersecting; setSticky(); }).observe(foot);
    sticky.querySelector('[data-sticky-add]').addEventListener('click', function () {
      var form = buy.closest('form');
      if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  }

  /* ---------- Subtiel infaden ---------- */
  var designMode = window.Shopify && Shopify.designMode;
  if (designMode) {
    var showAll = function () { document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); }); };
    showAll();
    document.addEventListener('shopify:section:load', showAll);
  } else if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
    setTimeout(function () {
      document.querySelectorAll('.reveal:not(.is-visible)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-visible');
      });
    }, 1200);
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }
})();
